import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useSelector } from 'react-redux';

import { getRoomByVitaRef } from 'src/api/bookingService';
import { selectQueryData } from 'src/store/slices/dual-occupant-slice';
import { selectUserLoggedIn } from 'src/store/slices/user-slice';
import { Building } from 'src/store/types/building';
import { Room } from 'src/store/types/room';

export const useFetchRoomByVitaRef = () => {
    const { vitaRef } = useSelector(selectQueryData);
    const hasVitaRef = vitaRef !== null && vitaRef.length > 0;
    const userLoggedIn = useSelector(selectUserLoggedIn);

    const query = useQuery<
        { room: Room; building: Building },
        AxiosError,
        { room: Room; building: Building }
    >({
        enabled: userLoggedIn && hasVitaRef,
        queryKey: ['booking', 'vitaRef'],
        queryFn: () => getRoomByVitaRef(vitaRef as string),
    });

    return {
        ...query,
    };
};
